<template>
	<button
		class="rounded-full bg-n-950 p-12px active:border-2 active:p-[10px] active:outline active:outline-2 active:outline-o-100-75% can-hover:hover:bg-n-500"
	>
		<BaseIcon name="arrow_top_new" class="block h-24px w-24px" />
	</button>
</template>

<script setup>
import BaseIcon from '@/components/ui/icon/BaseIcon.vue'
</script>
